var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Planned for today"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40840",
    d: "M6 24H44V38C44 41.3137 41.3137 44 38 44H12C8.68629 44 6 41.3137 6 38V24Z",
    fill: "#6BE3A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250695",
    d: "M20 15V6H30V15L25 12L20 15Z",
    fill: "#6BE3A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 40841",
    d: "M25 44H12C8.68629 44 6 41.3137 6 38V25V12C6 8.68629 8.68629 6 12 6H16H38C41.3137 6 44 8.68629 44 12V15V27",
    stroke: "#383434",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250696",
    d: "M28.5 39C28.5 39.2761 28.7239 39.5 29 39.5C29.2761 39.5 29.5 39.2761 29.5 39H28.5ZM29.3536 31.6464C29.1583 31.4512 28.8417 31.4512 28.6464 31.6464L25.4645 34.8284C25.2692 35.0237 25.2692 35.3403 25.4645 35.5355C25.6597 35.7308 25.9763 35.7308 26.1716 35.5355L29 32.7071L31.8284 35.5355C32.0237 35.7308 32.3403 35.7308 32.5355 35.5355C32.7308 35.3403 32.7308 35.0237 32.5355 34.8284L29.3536 31.6464ZM29.5 39V32H28.5V39H29.5Z",
    fill: "#383434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250697",
    d: "M36.5 39C36.5 39.2761 36.7239 39.5 37 39.5C37.2761 39.5 37.5 39.2761 37.5 39H36.5ZM37.3536 31.6464C37.1583 31.4512 36.8417 31.4512 36.6464 31.6464L33.4645 34.8284C33.2692 35.0237 33.2692 35.3403 33.4645 35.5355C33.6597 35.7308 33.9763 35.7308 34.1716 35.5355L37 32.7071L39.8284 35.5355C40.0237 35.7308 40.3403 35.7308 40.5355 35.5355C40.7308 35.3403 40.7308 35.0237 40.5355 34.8284L37.3536 31.6464ZM37.5 39V32H36.5V39H37.5Z",
    fill: "#383434"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrders);
export default __webpack_public_path__ + "static/media/totalOrders.764b30b7ac69c17a163ecdc612268761.svg";
export { ForwardRef as ReactComponent };